import { Link } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';

import { clientApi } from '@/config/axios';
import { useAuth } from '@/lib/auth/AuthContext';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
export function CoordinationQueue() {
  const { organization } = useAuth();
  const org = organization?.organization_id;
  const query = useQuery({
    enabled: !!org,
    refetchInterval: 30000,
    queryKey: ['coordination-queue', org],
    queryFn: async () =>
      (
        await clientApi.get<
          {
            id: string;
            patient_id: string;
            patient_name: string;
            label: string;
            status: string;
            owner: string;
            due_date: string;
          }[]
        >(`/api/v1/organizations/${org}/coordination/queue`)
      ).data,
  });
  return (
    <Card>
      <CardHeader>
        <CardTitle>Open patient tasks</CardTitle>
        <CardDescription>
          Up to 100 open or in-progress tasks. Manage each patient’s roadmap in the Checklist tab.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-3">
        {query.isError && <p role="alert">Patient tasks could not be loaded.</p>}
        {query.data?.length === 0 && <p>No open patient tasks.</p>}
        {query.data?.map((task) => (
          <div key={task.id}>
            <Link to="/patients/$patientId" params={{ patientId: task.patient_id }}>
              {task.patient_name}
            </Link>{' '}
            · {task.label} · {task.status.replaceAll('_', ' ')}
            {task.owner && ` · ${task.owner}`}
            {task.due_date && ` · Due ${task.due_date}`}
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
